export default class ParameterEligibleValue {
	public value: string;	
	public description: string;

	constructor(value: string, description: string) {
		this.value = value;
		this.description = description;
	}
}